import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=4baf84d8&scoped=true&"
import script from "./ProjectMembers.vue?vue&type=script&lang=js&"
export * from "./ProjectMembers.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMembers.vue?vue&type=style&index=0&id=4baf84d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf84d8",
  null
  
)

export default component.exports